import { DOTRejectionReasonTypeDto } from 'dtos/conformity'
import { DOTRejectionReasonType } from 'enums/conformity'
import * as yup from 'yup'

export interface VehicleConformityDOTRejectionDto {
  dotRejectionDateTime?: string
  dotRejectionReasonType?: DOTRejectionReasonTypeDto
  dotRejectionNote?: string
  dotRejectionLetterFileName?: string
  needsToBeSentBackToCanada?: boolean
  dotRejectionLetterFile?: File
}

// Design Spec does not specifically say which fields are required.
// After discussing with Mason Sommer and Matthew Regan, all fields
// (except Notes unless DOT Rejection Reason Type = Other) should be
// required.
// Maxwell Sommer 10/24/2025
export const dotRejectionValidationSchema = yup.object({
  dotRejectionDateTime: yup.string().typeError('Rejection Date is required.').required('Rejection Date is required.'),
  dotRejectionReasonType: yup.object().required('Rejection Reason is required.'),
  dotRejectionNote: yup
    .string()
    .max(200, 'Note cannot be more than 200 characters.')
    .when('dotRejectionReasonType.dotRejectionReasonTypeId', {
      is: DOTRejectionReasonType.Other,
      then: schema => schema.required('Note is required.'),
      otherwise: schema => schema.nullable()
    }),
  needsToBeSentBackToCanada: yup.boolean().required('Needs To Be Sent Back To Canada is required.'),
  dotRejectionLetterFile: yup.mixed().required('Rejection Letter is required.')
})
